export default {
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    let filter = '';
    if (state.searchText) {
      filter += `(oferta.titulo like '%${state.searchText.toLowerCase()}%')`;
    }
    return filter;
  },
};
